import type React from 'react';

import { DEFAULT_ACCEPT } from './constants';
import { useFileInput } from './use-file-input.hook';

import styles from './attachment-upload-button.module.scss';

interface AttachmentUploadButtonProps {
    onFileSelect: (file: File) => void;
    buttonText: string;
    accept?: string;
    icon?: React.ReactNode;
    small?: boolean;
    disabled?: boolean;
}

export const AttachmentUploadButton = ({
    onFileSelect,
    buttonText,
    accept = DEFAULT_ACCEPT,
    icon,
    small = false,
    disabled = false,
}: AttachmentUploadButtonProps) => {
    const { fileInputRef, openFileDialog, handleFileInputChange, clearInputValue } = useFileInput({
        onFileSelect,
    });

    return (
        <div className={styles.attachment_upload_button_container}>
            <input
                ref={fileInputRef}
                type="file"
                className={styles.attachment_upload_button_input}
                onChange={handleFileInputChange}
                onClick={clearInputValue}
                accept={accept}
                disabled={disabled}
                data-ot-attachment-upload-input
                data-testid="attachment-upload-button-input"
            />
            <button
                className={`${styles.attachment_upload_button}${small ? ` ${styles.attachment_upload_button_small}` : ''}`}
                onClick={openFileDialog}
                disabled={disabled}
                data-testid="attachment-upload-button"
                aria-label={buttonText}
            >
                {icon && <div className={styles.attachment_upload_button_icon}>{icon}</div>}
                {buttonText && <p>{buttonText}</p>}
            </button>
        </div>
    );
};
